var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import { useEffect, useState } from 'react';
import api from '@utils/axios';
import useDebounce from '@hooks/useDebounce';
import { endDateChangePreviewApiInternalInspectionSeriesPath } from '@routes';
import { toIsoDate } from './dateHelpers';
const useCancelCountPreview = (inspectionSeriesId, endDate) => {
    const [state, setState] = useState({ status: 'idle' });
    const requestedEndDate = endDate ? toIsoDate(endDate) : null;
    const debouncedEndDate = useDebounce(requestedEndDate, 300);
    useEffect(() => {
        if (!debouncedEndDate) {
            setState({ status: 'idle' });
            return undefined;
        }
        const controller = new AbortController();
        setState({ status: 'loading' });
        const fetchCount = () => __awaiter(void 0, void 0, void 0, function* () {
            try {
                const { data } = yield api.get(endDateChangePreviewApiInternalInspectionSeriesPath(inspectionSeriesId), { params: { end_date: debouncedEndDate }, signal: controller.signal });
                setState({ status: 'ready', count: data.count });
            }
            catch (error) {
                if ((error === null || error === void 0 ? void 0 : error.code) === 'ERR_CANCELED')
                    return;
                setState({ status: 'unavailable' });
            }
        });
        void fetchCount();
        return () => controller.abort();
    }, [inspectionSeriesId, debouncedEndDate]);
    // While the debounce is still catching up, `state` describes the *previous* date. Reporting it as
    // ready would enable Save next to a count that belongs to a date the user has already left, and
    // the confirmed change could cancel a different number of inspections than the one displayed.
    return requestedEndDate === debouncedEndDate ? state : { status: 'loading' };
};
export default useCancelCountPreview;
